__turbopack_context__.v({
  "active": "PageHeader-module-scss-module__3WXTza__active",
  "cta": "PageHeader-module-scss-module__3WXTza__cta",
  "environments": "PageHeader-module-scss-module__3WXTza__environments",
  "hamburger": "PageHeader-module-scss-module__3WXTza__hamburger",
  "header": "PageHeader-module-scss-module__3WXTza__header",
  "high-contrast": "PageHeader-module-scss-module__3WXTza__high-contrast",
  "logo": "PageHeader-module-scss-module__3WXTza__logo",
  "main-navigation": "PageHeader-module-scss-module__3WXTza__main-navigation",
  "my-bolt": "PageHeader-module-scss-module__3WXTza__my-bolt",
  "small-bar": "PageHeader-module-scss-module__3WXTza__small-bar",
});
